import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DashboardTarjetaService,
  PublicDataService,
  SeoService,
} from 'src/app/core/services';
import { UsersService } from 'src/app/core/services/users/users.service';
import { TabSize } from 'src/app/utils/constants';
import { PageTab } from 'src/app/utils/enums';
import {
  Gallery,
  PublicCardData,
  Services,
  SocialNetworks,
  Usuario,
} from 'src/app/utils/models';
import { EncryptService } from '../../../../core/services/encrypt/encrypt.service';
import { PromotionsService } from './modals';

@Component({
  selector: 'app-public-card',
  templateUrl: './public-card.component.html',
  styleUrls: ['./public-card.component.scss'],
})
export class PublicCardComponent implements OnInit, AfterViewInit {
  @HostListener('touchstart', ['$event'])
  @HostListener('touchend', ['$event'])
  @HostListener('touchcancel', ['$event'])
  handleTouch(event: any) {
    let touch = event.touches[0] || event.changedTouches[0];
    if (event.type === 'touchstart') {
      this.defaultTouch.x = touch.pageX;
      this.defaultTouch.y = touch.pageY;
      this.defaultTouch.time = event.timeStamp;
    } else if (event.type === 'touchend') {
      let deltaX = touch.pageX - this.defaultTouch.x;
      let deltaTime = event.timeStamp - this.defaultTouch.time;
      if (deltaTime < 500) {
        if (Math.abs(deltaX) > 60) {
          if (deltaX > 0) {
            this.doSwipeRight(event);
          } else {
            this.doSwipeLeft(event);
          }
        }
      }
    }
  }
  @ViewChild('page') page!: ElementRef;
  @ViewChild('mainCard') mainCard!: ElementRef;
  currentTab: number;
  defaultTouch = { x: 0, y: 0, time: 0 };
  language: string;
  nickName: string;
  publicCardData: PublicCardData;
  seoImage: string;
  socialNetworksList: SocialNetworks[];
  galleryList: Gallery[];
  servicesList: Services[];
  galleryCompanyList: any[];
  servicesCompanyList: any[];
  disable: boolean;
  logeado: boolean;
  sessionActive: boolean;
  userId: any;
  usuario: Usuario;
  esHorizontalEmpresa: boolean;
  esHorizontal: boolean;
  puedeVerInfo: boolean;
  constructor(
    private publicData: PublicDataService,
    private readonly route: ActivatedRoute,
    private readonly seo: SeoService,
    @Inject(DOCUMENT) document: any,
    private router: Router,
    private readonly encrypt: EncryptService,
    private readonly promotions: PromotionsService,
    private readonly dashboardTarjetaService: DashboardTarjetaService,
    private usersService: UsersService,
  ) {
    this.esHorizontalEmpresa = false;
    this.esHorizontal = false;
    this.currentTab = PageTab.PRESENTATION;
    this.language = this.publicData.idioma;
    this.nickName = '';
    this.publicCardData = new PublicCardData();
    this.seoImage = '';
    this.socialNetworksList = [];
    this.galleryList = [];
    this.servicesList = [];
    this.galleryCompanyList = [];
    this.servicesCompanyList = [];
    this.disable = false;
    this.logeado = false;
    this.sessionActive = this.validateSession();
    this.userId = this.encrypt.getSession().idUsuario;
    this.usuario = new Usuario();
    this.puedeVerInfo = true;
  }

  @HostListener('window:resize') onWindowResize() {
    let currentScroll = (window.innerWidth * TabSize.SIZE) / 100;

    switch (this.currentTab) {
      case PageTab.ABOUTME:
        this.moveScroll(0, true);
        this.currentTab = PageTab.ABOUTME;
        break;
      case PageTab.SERVICES:
        this.moveScroll(currentScroll * 2, true);
        this.currentTab = PageTab.SERVICES;
        break;
      default:
        this.moveScroll(currentScroll, true);
        this.currentTab = PageTab.PRESENTATION;
        break;
    }
  }

  async ngOnInit() {
    this.usuario = this.usersService.usuario;
    // console.log(this.usuario);

    const tarjetaPortada = this.usuario.tarjetaPortada;
    const tarjetaPortadaDetalle =
      this.usuario.tarjetaPortada.tarjetaPortadaDetalle;

    this.publicCardData.claveTelefono =
      tarjetaPortadaDetalle === null ||
      tarjetaPortadaDetalle.claveTelefono === ''
        ? this.usuario.claveTelefono
        : tarjetaPortadaDetalle.claveTelefono;
    this.publicCardData.colorLetra = tarjetaPortada.colorLetra;
    this.publicCardData.colorTarjeta = tarjetaPortada.colorTarjeta;
    this.publicCardData.colorFlecha = tarjetaPortada.colorFlecha;
    this.publicCardData.fondoFlecha = tarjetaPortada.fondoFlecha;
    this.publicCardData.correo =
      tarjetaPortadaDetalle === null ||
      tarjetaPortadaDetalle.correoProfesional === ''
        ? this.usuario.correo
        : tarjetaPortadaDetalle.correoProfesional;
    this.publicCardData.popup = tarjetaPortada.popup;
    this.publicCardData.empresa = tarjetaPortada.Empresa;
    this.publicCardData.crearTarjeta = this.usuario.crearTarjeta;
    this.publicCardData.descripcion = tarjetaPortadaDetalle.descripcion;
    this.publicCardData.domicilio = tarjetaPortadaDetalle.domicilio;
    this.publicCardData.editarTarjeta = this.usuario.editarTarjeta;
    this.publicCardData.esHorizontal = tarjetaPortada.esHorizontal;
    this.publicCardData.habilitado = this.usuario.habilitado;
    this.publicCardData.idTarjeta = tarjetaPortada.idTarjeta;
    this.publicCardData.idUsuario = this.usuario.idUsuario;
    this.publicCardData.iniciarSesion = this.usuario.iniciarSesion;
    this.publicCardData.nickName = this.usuario.alias;
    this.publicCardData.nombre = tarjetaPortada.nombre;
    this.publicCardData.profesion = tarjetaPortada.profesion;
    this.publicCardData.telefono =
      tarjetaPortadaDetalle === null || tarjetaPortadaDetalle.telefono === ''
        ? this.usuario.telefono
        : tarjetaPortadaDetalle.telefono;
    this.publicCardData.titulo = tarjetaPortadaDetalle.titulo;
    this.publicCardData.urlBanner = tarjetaPortada.urlBanner;
    this.publicCardData.urlFotoPerfil = tarjetaPortada.urlFotoPerfil;
    // this.publicCardData.urlLogo = tarjetaPortadaDetalle.urlLogo;
    this.publicCardData.urlLogotipo = tarjetaPortada.urlLogotipo;
    this.setColorCard();

    // this.buildImageSeo();

    await this.getSocialNetworks();
    await this.getUserGallery();
    await this.getUserServices();
    await this.getUserPlan();
    await this.getPopupTarjeta();

    if (this.usuario.empresa.idEmpresa != null) {
      const idEmpresa = this.usuario.empresa.idEmpresa;
      if (idEmpresa != 0) {
        await this.getCompanyServices(idEmpresa);
      }
    }

    this.publicCardData.empresa = this.usuario.tarjetaPortada.Empresa;
    if (this.userId !== this.usuario.idUsuario) {
      this.generateVisitor(this.usuario.tarjetaPortada.idTarjeta);
    }

    // let promo_status = false;
    // if (localStorage.getItem('promo_status')) {
    //   promo_status = JSON.parse(localStorage.getItem('promo_status')!);
    // }
    if (this.usuario.tarjetaPortada.popUpHabilitado) {
      this.promotions.open(this.usuario.tarjetaPortada);
    }
  }

  ngAfterViewInit(): void {
    this.initialAllocation();
  }

  initialAllocation(): void {
    const position = (window.innerWidth * TabSize.SIZE) / 100;
    this.page.nativeElement.scrollLeft += position;
  }

  moveScroll(scroll: number, isResize?: boolean): void {
    this.animationScroll(scroll, isResize);
    this.page.nativeElement.scrollLeft = scroll;
  }

  private doSwipeLeft(event: any): void {
    let currentScroll = (window.innerWidth * TabSize.SIZE) / 100;

    switch (this.currentTab) {
      case PageTab.PRESENTATION:
        this.moveScroll(currentScroll * 2);
        this.currentTab = PageTab.SERVICES;
        break;
      case PageTab.ABOUTME:
        this.moveScroll(currentScroll);
        this.currentTab = PageTab.PRESENTATION;
        break;
    }
  }

  private doSwipeRight(event: any): void {
    let currentScroll = (window.innerWidth * TabSize.SIZE) / 100;

    switch (this.currentTab) {
      case PageTab.PRESENTATION:
        this.moveScroll(0);
        this.currentTab = PageTab.ABOUTME;
        break;
      case PageTab.SERVICES:
        this.moveScroll(currentScroll);
        this.currentTab = PageTab.PRESENTATION;
        break;
    }
  }

  private animationScroll(scroll: number, isResize?: boolean): void {
    if (isResize) {
      return;
    }

    const htmlStyles = document.documentElement.style;
    const htmlScroll = this.page.nativeElement.scrollLeft;
    const mainCard = this.mainCard.nativeElement.classList;

    htmlStyles.setProperty('--initialScroll', htmlScroll + 'px');
    htmlStyles.setProperty('--endScroll', scroll + 'px');

    if (htmlScroll > scroll && scroll === 0) {
      mainCard.add('move-center-left');
      setTimeout(() => {
        mainCard.remove('move-center-left');
      }, 500);
      return;
    }

    if (htmlScroll < scroll && htmlScroll === 0) {
      mainCard.add('move-left-center');
      setTimeout(() => {
        mainCard.remove('move-left-center');
      }, 500);
      return;
    }

    if (htmlScroll < scroll) {
      mainCard.add('move-center-right');
      setTimeout(() => {
        mainCard.remove('move-center-right');
      }, 500);
      return;
    }

    this.mainCard.nativeElement.classList.add('move-right-center');
    setTimeout(() => {
      this.mainCard.nativeElement.classList.remove('move-right-center');
    }, 500);
    return;
  }

  // private assignParams(): string {
  //   return this.route.snapshot.params.nombre || '';
  // }

  // private buildImageSeo(): void {
  //   this.seoImage =
  //     DocumentsServe.COVERPHOTOS +
  //     this.publicCardData.idTarjeta +
  //     '/' +
  //     this.publicCardData.urlFotoPerfil;
  // }

  private generateVisitor(idTarjeta: number): void {
    this.publicData.generateVisitor(idTarjeta).subscribe((data) => {});
  }

  private getSocialNetworks() {
    return new Promise((resolve, reject) => {
      this.publicData
        .getSocialNetworks(
          +this.publicCardData.idTarjeta,
          +this.publicCardData.idUsuario,
          this.publicData.idioma,
        )
        .subscribe((response) => {
          this.socialNetworksList = response.objectResult;
          resolve(true);
        });
    });
  }

  private setColorCard(): void {
    //Checar que es lo que regresa

    var colorTarjeta: any;
    var colorLetra: any;
    var arrowColor: any;
    var arrorColorBg: any;

    if (this.usuario.empresa.configuracionEmpresa.colorTarjeta != '') {
      colorTarjeta = this.usuario.empresa.configuracionEmpresa.colorTarjeta;
    } else {
      colorTarjeta = this.usuario.tarjetaPortada.colorTarjeta;
    }

    if (this.usuario.empresa.configuracionEmpresa.colorLetra != '') {
      colorLetra = this.usuario.empresa.configuracionEmpresa.colorLetra;
    } else {
      colorLetra = this.usuario.tarjetaPortada.colorLetra;
    }

    if (this.usuario.empresa.configuracionEmpresa.colorFlecha != '') {
      arrowColor = this.usuario.empresa.configuracionEmpresa.colorFlecha;
    } else {
      arrowColor = this.usuario.tarjetaPortada.colorFlecha;
    }

    if (this.usuario.empresa.configuracionEmpresa.fondoFlecha != '') {
      arrorColorBg = this.usuario.empresa.configuracionEmpresa.fondoFlecha;
    } else {
      arrorColorBg = this.usuario.tarjetaPortada.fondoFlecha;
    }

    document.documentElement.style.setProperty('--page_back', colorTarjeta);
    document.documentElement.style.setProperty('--page_color', colorLetra);

    document.documentElement.style.setProperty('--arrow-color', arrowColor);
    document.documentElement.style.setProperty(
      '--arrow-color-bg',
      arrorColorBg,
    );
  }

  private getUserGallery() {
    return new Promise(async (resolve, reject) => {
      this.publicData
        .getUserGallery(
          +this.publicCardData.idTarjeta,
          +this.publicCardData.idUsuario,
          this.publicData.idioma,
        )
        .subscribe((response) => {
          this.galleryList = response.objectResult;
          resolve(true);
        });
    });
  }

  private getUserServices() {
    return new Promise(async (resolve, reject) => {
      this.publicData
        .getUserServices(
          this.publicCardData.idTarjeta,
          +this.publicCardData.idUsuario,
          this.publicData.idioma,
        )
        .subscribe((response) => {
          this.servicesList = response.objectResult;
          this.servicesList = this.servicesList.sort((a, b) => {
            return a.posicion - b.posicion;
          });

          if (this.usuario.empresa.idEmpresa !== null) {
            const idEmpresa = this.usuario.empresa.idEmpresa;
            this.getCompanyGallery(idEmpresa);
          }
          resolve(true);
        });
    });
  }

  private getCompanyGallery(idEmpresa: number) {
    return new Promise(async (resolve, reject) => {
      this.dashboardTarjetaService.getGaleriaV2(idEmpresa).subscribe((data) => {
        this.galleryList = [...this.galleryList, ...data.data];
        resolve(true);
      });
    });
  }

  private getCompanyServices(idEmpresa: number) {
    return new Promise(async (resolve, reject) => {
      this.dashboardTarjetaService
        .getServicesV2(idEmpresa)
        .subscribe((data) => {
          //
          //console.log("Vicman:: getCompanyServices", data);
          this.servicesCompanyList = [...data.data];
          resolve(true);
        });
    });
  }

  private getUserPlan() {
    return new Promise(async (resolve, reject) => {
      this.publicData
        .getUserPlan(+this.publicCardData.idUsuario, this.publicData.idioma)
        .subscribe((response) => {
          if (response.status === 1 && response.message === 'OK') {
            this.disable =
              response.objectResult[0].estatusPaquete === 0 ? true : false;
            resolve(true);
          }
        });
    });
  }
  private validateSession(): boolean {
    let session = false;
    if (
      this.encrypt.getSession() !== '' &&
      typeof this.encrypt.getSession().idUsuario === 'number'
    ) {
      session = true;
    }
    var diff = Math.abs(
      new Date(this.encrypt.getSession().FechaInicio).getTime() -
        new Date().getTime(),
    );
    var minutes = Math.floor(diff / 1000 / 60 / 60);
    if (minutes > 23) {
      session = false;
    }
    return session;
  }

  private getPopupTarjeta() {
    return new Promise((resolve, reject) => {
      //console.log("Vicman:: getPopupTarjeta",this.publicCardData.idTarjeta, this.publicCardData.idUsuario,this.publicData.idioma);

      this.publicData
        .getPopupTarjeta(
          this.publicCardData.idTarjeta,
          this.publicCardData.idUsuario,
          this.publicData.idioma,
        )
        .subscribe((response) => {
          if (response.objectResult === null) {
            this.usuario.tarjetaPortada.popUpHabilitado = 0;
            this.usuario.tarjetaPortada.tituloHabilitado = 0;
            this.usuario.tarjetaPortada.tituloPopUp = '';
            this.usuario.tarjetaPortada.preguntaHabilitado = 0;
            this.usuario.tarjetaPortada.pregunta = '';
            this.usuario.tarjetaPortada.respuestas = [];
            this.usuario.tarjetaPortada.imagenUrl = '';
            this.usuario.tarjetaPortada.redHabilitado = false;
          } else {
            this.usuario.tarjetaPortada.popUpHabilitado =
              response.objectResult.popUpHabilitado;
            this.usuario.tarjetaPortada.tituloHabilitado =
              response.objectResult.tituloHabilitado;
            this.usuario.tarjetaPortada.tituloPopUp =
              response.objectResult.titulo;
            this.usuario.tarjetaPortada.preguntaHabilitado =
              response.objectResult.preguntaHabilitado;
            this.usuario.tarjetaPortada.pregunta =
              response.objectResult.pregunta;
            this.usuario.tarjetaPortada.respuestas =
              response.objectResult.respuestas;
            this.usuario.tarjetaPortada.imagenUrl =
              response.objectResult.urlImagen;
            this.usuario.tarjetaPortada.redHabilitado =
              response.objectResult.esInstagram;
          }

          // Debug de seguimiento .. comentar despues
          console.log('Vicman:: public-card.ts/getPopupTarjeta A',response.objectResult);

          console.log(
            'popUpHabilitado: ',
            this.usuario.tarjetaPortada.popUpHabilitado,
          );
          console.log(
            'tituloHabilitado: ',
            this.usuario.tarjetaPortada.tituloHabilitado,
          );
          console.log('tituloPopUp: ', this.usuario.tarjetaPortada.tituloPopUp);
          console.log(
            'preguntaHabilitado: ',
            this.usuario.tarjetaPortada.preguntaHabilitado,
          );
          console.log('pregunta: ', this.usuario.tarjetaPortada.pregunta);
          console.log('respuestas: ', this.usuario.tarjetaPortada.respuestas);
          console.log('imagenUrl: ', this.usuario.tarjetaPortada.imagenUrl);
          console.log(
            'redHabilitado: ',
            this.usuario.tarjetaPortada.redHabilitado,
          );
          // Fin Debug de seguimiento .. comentar despues

          resolve(true);
        });
    });
  }
}
